import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { useControlledValue } from '../FormField/useControlledValue';
import { RadioGroupProps } from './RadioGroup.types';
import { injectRadioButtonProps } from './RadioGroup.utils';

const usePresenter = (props: RadioGroupProps) => {
  const {
    children,
    value,
    onValueChange,
    disabled,
    invalid,
    required,
    orientation = 'vertical',
  } = props;

  const { value: selectedValue, onValueChange: handleValueChange } = useControlledValue<string | number>({ value, onValueChange, defaultValue: '' });

  const variantProps = useBuildVariantProps(
    'radio-group',
    {
      orientation,
    },
    {
      disabled,
      invalid,
    },
  );

  return {
    radioButtons: injectRadioButtonProps(children, selectedValue, handleValueChange),
    orientation,
    variantProps,
  };
};

export default usePresenter;